@let hasChanges = cmsTicketCategoryService.isDirty();
@let isLoading = cmsTicketCategoryService.isLoading();
@if (isLoading) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (!isLoading) {
  <aw-section class="flex w-full flex-col" testIdAffix="ticketCategories">
    <aw-section-header>
      <aw-section-headline class="text-standard-text-primary">
        {{ cmsTextProvider.ticketCategories.headline }}
      </aw-section-headline>
      <aw-section-header-actions>
        <aw-button
          [id]="'save-entity'"
          [style]="'primary'"
          [isDisabled]="!hasChanges"
          (click)="save()"
          [type]="'submit'"
          [text]="cmsTextProvider.shared.save">
        </aw-button>
        <aw-button
          [id]="'discard-changes'"
          [style]="'primary-alt'"
          [type]="'reset'"
          [isDisabled]="!hasChanges"
          (click)="handleAbortChangesDialog()"
          [text]="cmsTextProvider.shared.cancel">
        </aw-button>
      </aw-section-header-actions>
    </aw-section-header>
    <aw-section
      class="flex w-full flex-col"
      testIdAffix="ticketCategoriesDirectTickets"
      [isCollapsible]="true"
      [isInitiallyCollapsed]="true">
      <aw-section-header>
        <aw-section-headline class="text-standard-text-primary">
          {{ cmsTextProvider.ticketCategories.directTicketCategories }}
        </aw-section-headline>
        <aw-section-header-actions>
          <aw-button
            [id]="'addTicketCategory'"
            [style]="'primary'"
            [type]="'reset'"
            (click)="handleAddTicketCategoryDialog(ETicketType.Direct)">
            <div class="flex items-center gap-2">
              <span class="material-symbols-rounded">add</span>
              <span>{{ cmsTextProvider.shared.add }}</span>
            </div>
          </aw-button>
        </aw-section-header-actions>
      </aw-section-header>
      <div class="flex h-full w-full items-start gap-4">
        <div class="flex w-1/4 flex-col gap-4">
          <div class="flex h-14 items-center">
            <div
              class="text-standard-text-primary text-2xl font-semibold"
              [ngClass]="
                cmsTicketCategoryService.fixedPriceTicketCategories().length ===
                0
                  ? 'opacity-50'
                  : ''
              ">
              {{ cmsTextProvider.sideBar.tickets }}
            </div>
          </div>

          <aw-unassigned-ticket-drag-and-drop-list
            [isDisabled]="
              cmsTicketCategoryService.fixedPriceTicketCategories().length === 0
            "
            [ticketType]="ETicketType.Direct">
          </aw-unassigned-ticket-drag-and-drop-list>
        </div>

        <div class="flex h-full w-3/4 flex-col gap-4">
          <div class="flex h-14 items-center justify-between gap-4">
            <div class="text-standard-text-primary text-2xl font-semibold">
              {{ cmsTextProvider.ticketCategories.categories }}
            </div>
          </div>

          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            cdkScrollable
            [cdkDropListAutoScrollStep]="5"
            [cdkDropListData]="
              cmsTicketCategoryService.fixedPriceTicketCategories()
            "
            (cdkDropListDropped)="
              dropCategory($event); isCategoryBeingDragged.set(false)
            "
            class="flex h-full w-full flex-row gap-4 overflow-x-auto"
            [ngClass]="
              isCategoryBeingDragged()
                ? 'border-info-main rounded-lg border-2'
                : ''
            ">
            @for (
              ticketCategory of cmsTicketCategoryService.fixedPriceTicketCategories();
              track ticketCategory.id
            ) {
              <div
                cdkDrag
                [cdkDragData]="ticketCategory"
                class="relative h-full min-h-1 shrink-0 basis-[calc((100%-2rem)/3)] transition-transform ease-in-out"
                (cdkDragStarted)="isCategoryBeingDragged.set(true)"
                (cdkDragEnded)="isCategoryBeingDragged.set(false)">
                <ng-template cdkDragPreview>
                  <div
                    class="!border-standard-outline-light !bg-standard-background !flex !justify-center !rounded-lg !border-1 !px-10 !py-2 !text-xl">
                    {{ ticketCategory.name }}
                  </div>
                </ng-template>

                <aw-ticket-category-drag-and-drop-list
                  [ticketCategory]="ticketCategory"
                  [id]="'category-' + ticketCategory.id">
                </aw-ticket-category-drag-and-drop-list>
              </div>
            }
          </div>
          @if (
            cmsTicketCategoryService.fixedPriceTicketCategories().length === 0
          ) {
            <span
              class="flex min-h-[calc(100vh-20rem)] items-center justify-center text-2xl">
              {{ cmsTextProvider.ticketCategories.noCategories }}
            </span>
          }
        </div>
      </div>
    </aw-section>
    <aw-section
      class="flex w-full flex-col"
      testIdAffix="ticketCategoriesRelationTickets"
      [isCollapsible]="true"
      [isInitiallyCollapsed]="true">
      <aw-section-header>
        <aw-section-headline class="text-standard-text-primary">
          {{ cmsTextProvider.ticketCategories.relationTicketCategories }}
        </aw-section-headline>
        <aw-section-header-actions>
          <aw-button
            [id]="'addRelationTicketCategory'"
            [style]="'primary'"
            [type]="'reset'"
            (click)="handleAddTicketCategoryDialog(ETicketType.Relation)">
            <div class="flex items-center gap-2">
              <span class="material-symbols-rounded">add</span>
              <span>{{ cmsTextProvider.shared.add }}</span>
            </div>
          </aw-button>
        </aw-section-header-actions>
      </aw-section-header>
      <div class="flex h-full w-full items-start gap-4">
        <div class="flex w-1/4 flex-col gap-4">
          <div class="flex h-14 items-center">
            <div
              class="text-standard-text-primary text-2xl font-semibold"
              [ngClass]="
                cmsTicketCategoryService.relationTicketCategories().length === 0
                  ? 'opacity-50'
                  : ''
              ">
              {{ cmsTextProvider.sideBar.tickets }}
            </div>
          </div>

          <aw-unassigned-ticket-drag-and-drop-list
            [isDisabled]="
              cmsTicketCategoryService.relationTicketCategories().length === 0
            "
            [ticketType]="ETicketType.Relation">
          </aw-unassigned-ticket-drag-and-drop-list>
        </div>

        <div class="flex h-full w-3/4 flex-col gap-4">
          <div class="flex h-14 items-center justify-between gap-4">
            <div class="text-standard-text-primary text-2xl font-semibold">
              {{ cmsTextProvider.ticketCategories.categories }}
            </div>
          </div>

          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            cdkScrollable
            [cdkDropListAutoScrollStep]="5"
            [cdkDropListData]="
              cmsTicketCategoryService.relationTicketCategories()
            "
            (cdkDropListDropped)="
              dropCategory($event); isCategoryBeingDragged.set(false)
            "
            class="flex h-full w-full flex-row gap-4 overflow-x-auto"
            [ngClass]="
              isCategoryBeingDragged()
                ? 'border-info-main rounded-lg border-2'
                : ''
            ">
            @for (
              ticketCategory of cmsTicketCategoryService.relationTicketCategories();
              track ticketCategory.id
            ) {
              <div
                cdkDrag
                [cdkDragData]="ticketCategory"
                class="relative h-full min-h-1 shrink-0 basis-[calc((100%-2rem)/3)] transition-transform ease-in-out"
                (cdkDragStarted)="isCategoryBeingDragged.set(true)"
                (cdkDragEnded)="isCategoryBeingDragged.set(false)">
                <ng-template cdkDragPreview>
                  <div
                    class="!border-standard-outline-light !bg-standard-background !flex !justify-center !rounded-lg !border-1 !px-10 !py-2 !text-xl">
                    {{ ticketCategory.name }}
                  </div>
                </ng-template>

                <aw-ticket-category-drag-and-drop-list
                  [ticketCategory]="ticketCategory"
                  [id]="'category-' + ticketCategory.id">
                </aw-ticket-category-drag-and-drop-list>
              </div>
            }
          </div>
          @if (
            cmsTicketCategoryService.relationTicketCategories().length === 0
          ) {
            <span
              class="flex min-h-[calc(100vh-20rem)] items-center justify-center text-2xl">
              {{ cmsTextProvider.ticketCategories.noCategories }}
            </span>
          }
        </div>
      </div>
    </aw-section>
  </aw-section>
}
